import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import {
    Container,
    Grid,
    Paper,
    CircularProgress,
    MenuItem
} from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import {
    Update as PRODUCT_UPDATE,
    Activate as PRODUCT_ACTIVATE,
    Insert as PRODUCT_ADD,
    Select as PRODUCT_SELECT_ALL,
    Delete as PRODUCT_DELETE
} from 'Components/Api/OfflineProductAPI';
import { Select as OPERATOR_SELECT_BY_SERVICEID } from 'Components/Api/OperatorsApi';
import { ConfirmAlert } from 'Components/Alert/ConfirmAlert';
import ReactTable from 'Components/ReactTable/ReactTable';
import {
    MESSAGE_CLOSE_AFTER,
    PLEASE_SELECT_VALID,
    PLEASE_PROVIDE_VALID,
    DTH_BOOKING
} from 'Components/Helper/Messages';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
const CustomContainer = HOCLoader(Container);

export const OfflineProduct = () => {
    const classes = commonStyle();
    const [itemList, setItemList] = useState([]);
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [mainColumns, setMainColumns] = useState([]);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [responseMessage, setResponseMessage] = useState('');
    const [IsUpdate, setIsUpdate] = useState(false);
    const [Operator, setOperator] = useState([]);

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});

    const selectData = async () => {
        const response = await PRODUCT_SELECT_ALL();
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }
        var data = JSON.parse(response.data);
        setItemList(data);
    };

    const activate = async (item, value) => {
        var jsonObj = {
            OfflineProductMasterID: item,
            IsActive: value
        };
        var request = JSON.stringify(jsonObj);
        setIsError(false);
        setLoadingOpen(true);
        const response = await PRODUCT_ACTIVATE(request);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        setIsError(true);
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }

        setSeverity('success');
        setResponseMessage(response.data);
        selectData();
    };

    const Edit = async (row) => {
        setIsUpdate(true);
        selectOperator(row[2]);
        setFormObject({
            ...formObject,
            OfflineProductMasterID: row[0],
            OpType: row[1],
            Name: row[2],
            OperatorID: row[3],
            PackageMRP: row[5],
            BookingAmount: row[6],
            Validity: row[7],
            Description: row[8],
            Remark: row[9]
        });
    };
    const Delete = async (request) => {
        var jsonReq = JSON.stringify(request);

        const response = await PRODUCT_DELETE(jsonReq);
        if (!response.isAuthorized) LOGOUT();

        setIsError(true);
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }

        setSeverity('success');
        setResponseMessage(response.data);
        selectData();
    };
    const onDeleteClick = (item) => {
        var RequestObj = { OfflineProductMasterID: item };
        setIsAlertOpen(true);
        setConfirmAlertRequest(RequestObj);
    };
    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'OfflineProductMasterID',
            srno: true
        });

        columns.push({
            label: 'OpType',
            name: 'OpType'
        });

        columns.push({
            label: 'Name',
            name: 'Name'
        });
        columns.push({
            label: 'OperatorID',
            name: 'OperatorID',
            hide: true
        });
        columns.push({
            label: 'Operator',
            name: 'OperatorName'
        });

        columns.push({
            label: 'Package MRP',
            name: 'PackageMRP',
            numeric: true
        });
        columns.push({
            label: 'Booking Amount',
            name: 'BookingAmount',
            numeric: true
        });
        columns.push({
            label: 'Validity',
            name: 'Validity'
        });
        columns.push({
            label: 'Desc',
            name: 'Description'
        });
        columns.push({
            label: 'Remark',
            name: 'Remark'
        });

        columns.push({
            label: 'Active',
            name: 'IsActive',
            activate: true,
            primaryKeyIndex: 0,
            callback: (id, value) => {
                activate(id, value);
            }
        });

        columns.push({
            label: 'Edit',
            name: 'Edit',
            buttonTitle: 'Edit',
            save: true,
            callback: (row) => {
                Edit(row);
            }
        });
        columns.push({
            label: 'Delete',
            name: 'OfflineProductMasterID',
            delete: true,
            callback: (value) => {
                onDeleteClick(value);
            }
        });

        setMainColumns(columns);
    };

    useEffect(() => {
        setLoadingOpen(true);
        createColumns();
        selectOperator(DTH_BOOKING);
        selectData();
    }, [DTH_BOOKING]);

    const selectOperator = async (DTH_BOOKING) => {
        if (
            DTH_BOOKING === null ||
            DTH_BOOKING === undefined ||
            DTH_BOOKING === 0 ||
            DTH_BOOKING === '0'
        )
            return;

        var requestObj = {
            ServiceID: DTH_BOOKING
        };
        var request = JSON.stringify(requestObj);

        const response = await OPERATOR_SELECT_BY_SERVICEID(request);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) setIsError(true);

        if (response.data !== 'Requested operators not found') {
            var data = JSON.parse(response.data);
            setOperator(data);
        }
    };

    const [formObject, setFormObject] = useState({
        OpType: 0,
        OperatorID: 0,
        Name: '',
        PackageMRP: '',
        BookingAmount: '',
        Validity: '',
        Description: '',
        Remark: ''
    });

    const FormValidationSchema = Yup.object({
        OperatorID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'operator')
            .required(PLEASE_SELECT_VALID + 'operator'),

        Name: Yup.string().required(PLEASE_PROVIDE_VALID + 'name'),

        OpType: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'OpType')
            .required(PLEASE_SELECT_VALID + 'OpType'),

        PackageMRP: Yup.number()
            .moreThan(9, PLEASE_PROVIDE_VALID + 'Minimum 10 MRP')
            .required(PLEASE_PROVIDE_VALID + 'minimum MRP'),
        BookingAmount: Yup.number()
            .moreThan(9, PLEASE_PROVIDE_VALID + 'Minimum 10 Amount')
            .required(PLEASE_PROVIDE_VALID + 'minimum Amount'),

        Validity: Yup.string().required(PLEASE_PROVIDE_VALID + 'Validity'),

        Description: Yup.string().required(PLEASE_PROVIDE_VALID + 'description')
    });

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        if (loadingOpen) {
            setLoadingOpen(false);
            return;
        }
        var requestObj = JSON.stringify(values);
        setSubmitting(false);
        setIsError(false);
        setLoadingOpen(true);
        var response = IsUpdate
            ? await PRODUCT_UPDATE(requestObj)
            : await PRODUCT_ADD(requestObj);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        setSubmitting(false);

        setIsError(true);
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }

        setSeverity('success');
        setResponseMessage(response.data);
        setIsUpdate(false);
        resetForm(formObject);
        setFormObject({
            OpType: 0,
            OperatorID: 0,
            Name: '',
            PackageMRP: '',
            BookingAmount: '',
            Validity: '',
            Description: '',
            Remark: ''
        });
        setTimeout(() => {
            selectData();
        }, MESSAGE_CLOSE_AFTER);
    };
    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
            >
                {({ setFieldValue, handleSubmit }) => {
                    return (
                        <Form style={{ marginBottom: '15px' }}>
                            <h2 className={classes.PaperHead_h2}>Service </h2>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <MaterialSelect
                                                label="Operator"
                                                name="OperatorID"
                                            >
                                                <MenuItem key="0" value="0">
                                                    Select Operator
                                                </MenuItem>
                                                {Operator.map((Item) => (
                                                    <MenuItem
                                                        key={Item.OperatorID}
                                                        value={Item.OperatorID}
                                                    >
                                                        {Item.OperatorName}
                                                    </MenuItem>
                                                ))}
                                            </MaterialSelect>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <MaterialSelect
                                                label="OpType"
                                                name="OpType"
                                            >
                                                <MenuItem key="0" value="0">
                                                    Select OpType
                                                </MenuItem>

                                                <MenuItem
                                                    key="SD BOX"
                                                    value="SD BOX"
                                                >
                                                    SD BOX
                                                </MenuItem>
                                                <MenuItem
                                                    key="HD BOX"
                                                    value="HD BOX"
                                                >
                                                    HD BOX
                                                </MenuItem>
                                            </MaterialSelect>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Package Name"
                                                name="Name"
                                                type="text"
                                                placeholder="Package Name"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <MaterialNumberField
                                                label="Package MRP"
                                                name="PackageMRP"
                                                type="text"
                                                length={7}
                                                placeholder="Package MRP"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <MaterialNumberField
                                                label="Booking Amount"
                                                name="BookingAmount"
                                                type="text"
                                                length={7}
                                                placeholder="Booking Amount"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <MaterialNumberField
                                                label="Validity(In Days)"
                                                name="Validity"
                                                type="text"
                                                length={10}
                                                placeholder="Validity(In Days)"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Description"
                                                name="Description"
                                                type="text"
                                                placeholder="Description"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Remark"
                                                name="Remark"
                                                type="text"
                                                placeholder="Remark"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <PrimaryButton
                                                type="submit"
                                                title="Save"
                                                className={
                                                    classes.CustomPrimaryButtonStyle
                                                }
                                                disabled={loadingOpen}
                                            >
                                                {IsUpdate ? 'Update' : 'Add'}
                                            </PrimaryButton>
                                            {loadingOpen && (
                                                <CircularProgress
                                                    size={24}
                                                    className={
                                                        classes.buttonProgress
                                                    }
                                                />
                                            )}
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
            {isAlertOpen ? (
                <ConfirmAlert
                    isOpen={isAlertOpen}
                    title="Delete Confirmation"
                    message="Are you sure to delete this Product"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        Delete(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}

            <ReactTable data={itemList} columns={mainColumns} />
        </CustomContainer>
    );
};
